/**
 * iGuard Product Logic — Exact matching iguard.se
 */
document.addEventListener('DOMContentLoaded', function () {
  // 1. Initialize Image Swiper
  if (typeof Swiper !== 'undefined') {
    const thumbEl = document.querySelector('.g-pdp-images-main-thumbnail');
    const mainEl = document.querySelector('.g-pdp-images-slider');

    let mainThumb = null;
    if (thumbEl) {
      mainThumb = new Swiper(thumbEl, {
        watchSlidesProgress: true,
        spaceBetween: 12,
        slidesPerView: 5,
        freeMode: true,
      });
    }

    if (mainEl) {
      new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.g-next',
          prevEl: '.g-prev',
        },
        thumbs: {
          swiper: mainThumb,
        },
      });
    }

    // 2. Initialize UGC Video Swiper
    const videoSwiperEl = document.querySelector('.g-pdp-videos-slider');
    if (videoSwiperEl) {
      new Swiper(videoSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  // 3. Video Player Controls
  document.querySelectorAll('.g-pdp-video').forEach((videoContainer) => {
    const playButtonWrap = videoContainer.querySelector('.g-video-play-wrap');
    const playButton = videoContainer.querySelector('.g-video-play');
    const video = videoContainer.querySelector('video');

    if (!video || !playButton) return;

    videoContainer.addEventListener('mouseenter', () => {
      if (video.paused && playButtonWrap) {
        playButtonWrap.style.display = 'flex';
        playButton.style.display = 'flex';
      }
    });

    videoContainer.addEventListener('mouseleave', () => {
      if (video.paused && playButtonWrap) {
        playButtonWrap.style.display = 'flex';
        playButton.style.display = 'flex';
      } else if (playButtonWrap) {
        playButtonWrap.style.display = 'none';
        playButton.style.display = 'none';
      }
    });

    const togglePlay = () => {
      if (video.paused) {
        video.play();
        if (playButtonWrap) playButtonWrap.style.display = 'none';
        if (playButton) playButton.style.display = 'none';
      } else {
        video.pause();
        if (playButtonWrap) playButtonWrap.style.display = 'flex';
        if (playButton) playButton.style.display = 'flex';
      }
    };

    playButton.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePlay();
    });

    video.addEventListener('click', togglePlay);
  });

  // 4. Accordion Toggle
  document.querySelectorAll('.g-product-information .g-accordion-header').forEach((header) => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      if (!content) return;

      header.classList.toggle('g-active');
      content.classList.toggle('open');
    });
  });

  // 5. Low Stock Counter
  (function initStockCounter() {
    const root = document.getElementById('ig-low-stock');
    if (!root) return;

    const bar = root.querySelector('.ig-fill');
    const pctEl = root.querySelector('.ig-pct');
    const barWrap = root.querySelector('.ig-bar');

    const START = 89;
    const STEPS = [
      { target: 90, delay: 20 * 1000 },
      { target: 91, delay: 80 * 1000 },
      { target: 92, delay: 200 * 1000 },
      { target: 93, delay: 320 * 1000 },
      { target: 94, delay: 440 * 1000 },
    ];
    const MAX = STEPS[STEPS.length - 1].target;
    const KEY = 'ig_stock_pct_' + (window.iGuardProduct?.id || 'default');

    let current = parseInt(localStorage.getItem(KEY), 10);
    if (isNaN(current)) current = START;
    if (current > MAX) current = MAX;

    function render(val) {
      const label = (window.iGuardI18n?.soldPercent || '__PCT__%').replace('__PCT__', String(val));
      if (bar) bar.style.width = val + '%';
      if (pctEl) pctEl.textContent = label;
      if (barWrap) barWrap.setAttribute('aria-label', label);
    }

    render(current);

    STEPS.forEach((step) => {
      if (current < step.target) {
        setTimeout(() => {
          let stored = parseInt(localStorage.getItem(KEY), 10);
          if (!isNaN(stored)) current = stored;
          if (current >= MAX || current >= step.target) return;
          current = Math.min(step.target, MAX);
          localStorage.setItem(KEY, String(current));
          render(current);
        }, step.delay);
      }
    });
  })();

  // 6. Bundle Pack & Device Selectors
  let currentPack = 2; // default Duo
  const variants = document.querySelectorAll('.g-variant');
  const pack1 = document.getElementById('pack-1');
  const pack2 = document.getElementById('pack-2');
  const pack3 = document.getElementById('pack-3');
  const packNameEl = document.querySelector('.g-packs-name');
  const packSaleEl = document.querySelector('.g-packs-pricing-sale');
  const packCompareEl = document.querySelector('.g-packs-pricing-compare');
  const ctaSaleEl = document.querySelector('.g-cta-sale');
  const ctaCompareEl = document.querySelector('.g-cta-compare');

  let currentPaketVal = document.querySelector('.g-variant-selected')?.getAttribute('data-paket-val') || '';

  function updateDisplayedPricing(variantEl) {
    if (!variantEl) return;
    const title = variantEl.querySelector('.g-variant-title')?.textContent.trim() || '';
    const sale = variantEl.querySelector('.g-variant-sale')?.textContent.trim() || '';
    const compare = variantEl.querySelector('.g-variant-compare')?.textContent.trim() || '';

    if (packNameEl && title) packNameEl.textContent = title;
    if (packSaleEl && sale) packSaleEl.textContent = sale;
    if (packCompareEl) {
      packCompareEl.textContent = compare;
      packCompareEl.style.display = compare ? '' : 'none';
    }
    if (ctaSaleEl && sale) {
      ctaSaleEl.textContent = sale;
    }
    if (ctaCompareEl) {
      ctaCompareEl.textContent = compare;
      ctaCompareEl.style.display = compare ? '' : 'none';
    }
  }

  // Initial sync on load
  const initialVariant = document.querySelector('.g-variant-selected') || variants[0];
  if (initialVariant) {
    updateDisplayedPricing(initialVariant);
  }

  variants.forEach((variant) => {
    variant.addEventListener('click', function () {
      variants.forEach((v) => v.classList.remove('g-variant-selected'));
      this.classList.add('g-variant-selected');

      const pack = parseInt(this.getAttribute('data-pack'), 10) || 1;
      currentPack = pack;
      currentPaketVal = this.getAttribute('data-paket-val') || '';

      updateDisplayedPricing(this);

      // Show/hide device packs
      if (pack === 1) {
        if (pack1) pack1.style.display = 'block';
        if (pack2) pack2.style.display = 'none';
        if (pack3) pack3.style.display = 'none';
      } else if (pack === 2) {
        if (pack1) pack1.style.display = 'block';
        if (pack2) pack2.style.display = 'block';
        if (pack3) pack3.style.display = 'none';
      } else if (pack >= 3) {
        if (pack1) pack1.style.display = 'block';
        if (pack2) pack2.style.display = 'block';
        if (pack3) pack3.style.display = 'block';
      }
    });
  });

  // 7. Add to Cart Handler — adds each selected device as a distinct variant line item
  const atcBtn = document.getElementById('iguard-main-atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      const product = window.iGuardProduct || {};
      const productVariants = product.variants || [];

      const packElements = [pack1, pack2, pack3].slice(0, currentPack);
      const i18n = window.iGuardI18n || {};
      const packName =
        currentPaketVal ||
        (currentPack === 1
          ? i18n.packSolo || 'Pakiet Solo'
          : currentPack === 2
            ? i18n.packDuo || 'Podwójne opakowanie'
            : i18n.packFamily || 'Opakowanie rodzinne');

      const bundleGroupId = `bundle_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
      const itemsToAdd = [];

      packElements.forEach((packEl, index) => {
        if (!packEl || packEl.style.display === 'none') return;

        const selectedVals = [];
        const details = [];

        packEl.querySelectorAll('select').forEach((sel) => {
          const val = sel.value?.trim();
          let optName =
            sel.getAttribute('data-option-name') ||
            sel.previousElementSibling?.textContent?.replace(':', '').trim() ||
            '';
          if (optName.toLowerCase() === 'nadal' || optName.toLowerCase() === 'stil') {
            optName = 'Styl';
          }
          if (val) {
            selectedVals.push(val);
            details.push(optName ? `${optName}: ${val}` : val);
          }
        });

        // Match the specific variant for this device
        let matchedVariant = null;

        const matchingVariants = productVariants.filter((v) => {
          const optList = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          return selectedVals.every((val) => optList.includes(val));
        });

        if (matchingVariants.length > 0) {
          // If the product has a pack option (Solo / Duo / Family), prefer the Solo/single-pack
          // variant so inventory is tracked for this individual unit
          matchedVariant =
            matchingVariants.find((v) => {
              const optList = (v.options || [v.option1, v.option2, v.option3].filter(Boolean)).map((o) =>
                String(o).toLowerCase()
              );
              return optList.some(
                (o) =>
                  o.includes('solo') ||
                  o.includes('1') ||
                  o.includes('single') ||
                  o.includes('jednostkow') ||
                  o.includes('szt')
              );
            }) || matchingVariants[0];
        }

        // If not matched by all options, match by device model/options partially
        if (!matchedVariant && selectedVals.length > 0) {
          matchedVariant = productVariants.find((v) => {
            const optList = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
            return selectedVals.some((val) => optList.includes(val));
          });
        }

        // Fallback to first variant if needed
        if (!matchedVariant) {
          matchedVariant = productVariants[0];
        }

        if (matchedVariant && matchedVariant.id) {
          const deviceLabel = `${i18n.device || 'Urządzenie'} #${index + 1}`;
          const deviceSpecs = details.length > 0 ? details.join(' | ') : i18n.standard || 'Standard';

          const itemProperties = {
            [deviceLabel]: deviceSpecs,
          };

          if (currentPack > 1) {
            itemProperties._bundle_id = bundleGroupId;
            itemProperties._bundle_pack = packName;
            itemProperties._bundle_unit = String(index + 1);
            itemProperties._bundle_total = String(packElements.length);
            itemProperties._device_index = deviceLabel;
            itemProperties[i18n.pack || 'Pakiet'] = packName;
          }

          itemsToAdd.push({
            id: matchedVariant.id,
            quantity: 1,
            properties: itemProperties,
          });
        }
      });

      if (itemsToAdd.length === 0) {
        alert(i18n.cartError || 'Wystąpił błąd podczas dodawania do koszyka.');
        return;
      }

      const originalText = atcBtn.innerHTML;
      atcBtn.disabled = true;
      atcBtn.style.opacity = '0.7';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: itemsToAdd,
          sections: 'cart-drawer-section',
        }),
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((json) => {
              throw new Error(json.description || json.message || 'Cart error');
            });
          }
          return res.json();
        })
        .then((data) => {
          atcBtn.disabled = false;
          atcBtn.style.opacity = '1';

          // Update cart drawer dialog markup from Section Rendering API if present
          if (data.sections && data.sections['cart-drawer-section']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['cart-drawer-section'], 'text/html');
            const newDialog = doc.querySelector('theme-drawer#cart-drawer dialog');
            const currentDialog = document.querySelector('theme-drawer#cart-drawer dialog');
            if (newDialog && currentDialog) {
              currentDialog.innerHTML = newDialog.innerHTML;
            }
          }

          // Refresh header cart count bubble
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              document.querySelectorAll('.iguard-header__cart-count').forEach((el) => {
                el.textContent = cart.item_count;
              });
              document.querySelectorAll('#cart-icon-bubble').forEach((btn) => {
                let badge = btn.querySelector('.iguard-header__cart-count');
                if (!badge && cart.item_count > 0) {
                  badge = document.createElement('span');
                  badge.className = 'iguard-header__cart-count';
                  badge.textContent = cart.item_count;
                  btn.appendChild(badge);
                } else if (badge) {
                  badge.textContent = cart.item_count;
                }
              });
            })
            .catch(() => {});

          // Dispatch theme and shopify standard events
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
          document.dispatchEvent(
            new CustomEvent('shopify:cart:lines-update', {
              bubbles: true,
              detail: { action: 'add', sections: data.sections },
            })
          );
          document.dispatchEvent(new Event('gOpenCart'));

          // Open cart drawer directly via theme-drawer component
          const themeDrawer =
            document.querySelector('theme-drawer#cart-drawer') || document.querySelector('#cart-drawer');
          if (themeDrawer && typeof themeDrawer.open === 'function') {
            themeDrawer.open();
          } else {
            const cartDrawerComp = document.querySelector('cart-drawer-component');
            const closestDrawer = cartDrawerComp ? cartDrawerComp.closest('theme-drawer') : null;
            if (closestDrawer && typeof closestDrawer.open === 'function') {
              closestDrawer.open();
            } else {
              window.location.href = '/cart';
            }
          }
        })
        .catch((err) => {
          console.error('Add to cart error:', err);
          atcBtn.disabled = false;
          atcBtn.style.opacity = '1';
          atcBtn.innerHTML = originalText;
          window.location.href = '/cart';
        });
    });
  }
});
